import data_cards from '@/data/cards'

const Generator = {}


Generator.get_random_number_by_rates = function(rates) {
	var total = 0
	_.forIn(rates, function(value, key) { total += value })

	var r = _.random(0, total)
	var result = 0
	var j = 0
	_.forIn(rates, function(value, key) {
		j += value
		if (r <= j) {
			result = key
			return false
		}
	})
	return result
}


// Generator.get_random_card_by_rates = function(rates) {
// 	var type = Generator.get_random_number_by_rates(rates)
// 	return Generator.get_random_card({ type: type })
// }


Generator.get_random_card = function(params) {
	var card = {}
	
	if (params.type) {
		if (params.slug) {
			card = _.find(data_cards[params.type], { slug: params.slug })
		}
		else if (params.biome) {
			if (params.boss) {
				card = _.last(data_cards[params.type][params.biome])
			}
			else if (params.value) {
				card = _.find(data_cards[params.type][params.biome], { value: parseInt(params.value) })
			}
			else {
				card = _.sample(_.dropRight(data_cards[params.type][params.biome]), 1)
			}
		}
		else if (params.value) {
			card = _.find(data_cards[params.type], { value: params.value })
		}
		else {
			card = _.sample(data_cards[params.type])
		}
	}

	if (card) return _.cloneDeep(card)
	return {}
}


export default Generator